import React, { memo, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Select,
  withStyles,
  InputBase,
  FormControl,
  MuiThemeProvider,
} from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from '@material-ui/core/styles';
import { scrollToTop } from '../../../shared/utils/smartutils';
import { SCHOOL_TERM_STATUS } from '../../../shared/utils/constants';

const OptionsTerms = (props) => {
  const { terms, input, meta, dto, handleChange } = props;

  const BootstrapInput = withStyles(() => ({
    input: {
      position: 'relative',
      backgroundColor: '#fff',
      padding: '5px 0px 0px 11px',
      fontSize: 13,
      maxHeight: 32,
      fontFamily: ['Roboto', 'sans-serif'].join(','),
    },
  }))(InputBase);

  const useStyles = makeStyles((theme) => ({
    formControl: {
      marginTop: 7,
      minWidth: '100%',
      height: 33,
      backgroundColor: '#fff',
      borderRadius: 3,
      border: '1px solid #dee2e6',
    },
    selectEmpty: {
      marginTop: theme.spacing(0),
    },

    FormHelperText: {
      paddingLeft: 17,
    },

    Select: {
      maxWidth: '100%',
      fontSize: 13,
      color: '#30313f',
      height: '2rem',
    },
  }));

  const theme = createMuiTheme({
    overrides: {
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: '#fff',
            color: 'red',
          },
        },
      },
    },
  });

  const classes = useStyles();

  const menuItems = terms.map((item) => (
    <MenuItem
      className={classes.Select}
      key={item.id}
      value={item.id}
      name={item.name}
      disabled={item.status === SCHOOL_TERM_STATUS.FINISHED}
    >
      {item.name}
    </MenuItem>
  ));

  const termChange = (value) => {
    return terms.find((cl) => cl.id === value);
  };

  const changeSelected = (id) => {
    input.onChange(termChange(id));
    handleChange(termChange(id));
  };

  useEffect(() => {
    input.onChange(termChange(input.value.id));
  }, []);

  useEffect(() => {
    handleChange(termChange(input.value.id));
  }, [input.value]);

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
          <FormControl variant="outlined" className={classes.formControl}>
            <Select
              displayEmpty
              input={<BootstrapInput />}
              className={classes.Select}
              disabled={dto.id > 0}
              value={input.value.id}
              onChange={(event) => changeSelected(event.target.value)}
            >
              {menuItems}
            </Select>
          </FormControl>
          {meta.touched && meta.error && (
            <span className="form__form-group-error">
              {meta.error}
              {scrollToTop()}
            </span>
          )}
        </div>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

OptionsTerms.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  input: PropTypes.shape(PropTypes.shape).isRequired,
  handleChange: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  dto: PropTypes.shape(PropTypes.shape).isRequired,
};

OptionsTerms.defaultProps = {
  meta: {
    touched: false,
    error: '',
  },
};

export default withTranslation('common')(memo(OptionsTerms));
